import type { IconName } from '@fortawesome/fontawesome-svg-core';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { HelperText, TextDiv, WrapperDiv } from './Status.style';

function selectColor(variant: string): string {
  switch (variant) {
    case 'danger':
      return 'error.main';
    case 'info':
      return 'info.main';
    case 'blue':
      return 'primary.main';
    case 'red':
      return 'secondary.main';
    case 'success':
    case 'green':
      return 'success.main';
    case 'orange':
      return 'warning.dark';
    // case 'pink':
    //   return 'pink.main';
    case 'grey':
      return 'text.secondary';
    case 'warning':
    case 'yellow':
    default:
      return 'warning.main';
  }
}

export default function Status({
  variant = 'yellow',
  position = 'right',
  size = '14px',
  greyText = false,
  children = null,
  helperText = '',
  helperTextColor = '',
  icon = 'circle-small',
}: {
  variant?:
    | ''
    | 'blue'
    | 'danger'
    | 'green'
    | 'grey'
    | 'orange'
    | 'red'
    | 'success'
    | 'warning'
    | 'yellow';
  position?: '' | 'left' | 'right';
  size?: string;
  greyText?: boolean;
  children?: React.ReactNode;
  helperText?: string;
  helperTextColor?: string;
  icon?: IconName;
}) {
  const color = selectColor(variant);

  return (
    <WrapperDiv position={position}>
      <Icon
        data-testid="circle-small-icon"
        color={color}
        name={icon}
        type="fas"
      />
      <TextDiv
        color={color}
        data-testid="status-textdiv"
        greyText={greyText}
        size={size}
      >
        {children}
        {helperText ? (
          <HelperText color={helperTextColor} data-testid="status-helpertext">
            {helperText}{' '}
          </HelperText>
        ) : null}
      </TextDiv>
    </WrapperDiv>
  );
}
